<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <!-- c-snackbar -->
      <c-snackbar
        v-model="snackbar.isVisible"
        :message="snackbar.message"
        :type="snackbar.type"
      ></c-snackbar>

      <!-- brand logo -->
      <router-link
        to="/"
        class="brand-logo d-flex align-center"
      >
        <v-img
          :src="appLogo"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          class="me-3 "
        ></v-img>

        <h2 class="text--primary">
          {{ appName }}
        </h2>
      </router-link>
      <!--/ brand logo -->

      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- triangle bg -->
            <img
              height="362"
              class="auth-mask-bg"
              :src="require(`@/assets/images/misc/mask-v2-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
            />

            <!-- tree -->
            <v-img
              height="226"
              width="300"
              class="auth-tree"
              src="@/assets/images/misc/tree-4.png"
            ></v-img>

            <!-- 3d character -->
            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                contain
                max-width="100%"
                height="400"
                class="auth-3d-group"
                :src="require(`@/assets/images/3d-characters/group-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
              ></v-img>
            </div>
          </div>
        </v-col>

        <v-col
          lg="4"
          class="d-flex align-center auth-bg pa-10 pb-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <v-card-text>
                  <p
                    class="text-2xl font-weight-semibold text--primary mb-2"
                  >
                    Login
                  </p>
                </v-card-text>

                <!-- login form -->
                <v-card-text>
                  <v-form
                    ref="form"
                    v-model="valid"
                    @submit.prevent="onSubmit"
                  >
                    <v-text-field
                      v-model="formData.email"
                      outlined
                      label="Email"
                      hide-details="auto"
                      class="mb-6"
                      :rules="[validators.required, validators.emailValidator]"
                      :error-messages="errors.email"
                      dense
                      @change="errors.email = []"
                    ></v-text-field>

                    <v-text-field
                      v-model="formData.password"
                      outlined
                      :type="isPasswordVisible ? 'text' : 'password'"
                      label="Password"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      hide-details="auto"
                      class="mb-2"
                      :rules="[validators.passwordValidator]"
                      :error-messages="errors.password"
                      dense
                      @click:append="isPasswordVisible = !isPasswordVisible"
                      @change="errors.password = []"
                    ></v-text-field>

                    <div
                      class="d-flex align-center justify-space-between flex-wrap"
                    >
                      <!-- forget link -->
                      <router-link :to="{name:'auth.forgot-password'}">
                        Forgot Password?
                      </router-link>
                    </div>

                    <v-card-text
                      class="d-flex align-center justify-center mt-4"
                      style="color:red;"
                    >
                      {{ errorMessage }}
                    </v-card-text>
                    <v-btn
                      block
                      color="primary"
                      type="submit"
                    >
                      Login
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import themeConfig from '@themeConfig'
import { required, emailValidator, passwordValidator } from '@core/utils/validation'

export default {
	data() {
		return {
			formData: {
				email: '',
				password: '',
			},
			valid: false,
			errors: {},
			errorMessage: null,
			appName: themeConfig.app.name,
			appLogo: themeConfig.app.logo,
			icons: {
				mdiEyeOutline,
				mdiEyeOffOutline,
			},
			isPasswordVisible: false,
			validators: { required, emailValidator, passwordValidator },
			snackbar: {
				isVisible: false,
				message: '',
				type: 'info',
			},
		}
	},
	methods: {
		onSubmit() {
			if (this.valid) {
				this.errorMessage = ''
				this.$store
					.dispatch('auth/login', this.formData)
					.then(() => {
						this.$router.push({ name: 'home' }).catch(() => {})
					})
					.catch(error => {
						const { errors, message } = error.response.data
						if (errors) {
							this.$set(this, 'errors', errors)
							this.$set(this, 'valid', false)
						}
						this.errorMessage = message
					})
			} else {
				this.$refs.form.validate()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
</style>
